import { render } from "./PfInputNumber.vue?vue&type=template&id=5e3ece42"
import script from "./PfInputNumber.vue?vue&type=script&lang=js"
export * from "./PfInputNumber.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__